import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import PwaInstallPrompt from './components/PwaInstallPrompt';
import Layout from './components/Layout/Layout';
import Login from './pages/Login';
import RecuperarSenha from './pages/RecuperarSenha';
import RedefinirSenha from './pages/RedefinirSenha';
import Dashboard from './pages/Dashboard';
import LeadsList from './pages/Leads/LeadsList';
import LeadKanban from './pages/Leads/LeadKanban';
import LeadDetail from './pages/Leads/LeadDetail';
import LeadsReaquecidosList from './pages/LeadsReaquecidos/LeadsReaquecidosList';
import LeadsSDRVoz from './pages/Leads/LeadsSDRVoz';
import EmpreendimentosList from './pages/Empreendimentos/EmpreendimentosList';
import EspelhoVendas from './pages/Empreendimentos/EspelhoVendas';
import PipelineKanban from './pages/Pipeline/PipelineKanban';
import PortaisSync from './pages/Portais/PortaisSync';
import Integracoes from './pages/Configuracoes/Integracoes';
import ImovelList from './pages/Imoveis/ImovelList';
import ImovelForm from './pages/Imoveis/ImovelForm';
import ImovelDetail from './pages/Imoveis/ImovelDetail';
import GerarDeUnidade from './pages/Imoveis/GerarDeUnidade';
import UsuariosList from './pages/Usuarios/UsuariosList';
import PortalClientesList from './pages/PortalClientes/PortalClientesList';
import EvolucaoObra from './pages/PortalClientes/EvolucaoObra';
import Chamados from './pages/PortalClientes/Chamados';
import ReajusteINCC from './pages/PortalClientes/ReajusteINCC';
import PropostasList from './pages/Propostas/PropostasList';
import PreReservasList from './pages/PreReservas/PreReservasList';
import ClientesList from './pages/Vendas/ClientesList';
import CorretoresList from './pages/Vendas/CorretoresList';
import ParceirosList from './pages/Vendas/ParceirosList';
import ParceiroDetail from './pages/Vendas/ParceiroDetail';
import CorretoresReaquecidos from './pages/Vendas/CorretoresReaquecidos';
import Elo from './pages/Vendas/Elo';
import FunilCorretoresKanban from './pages/Vendas/FunilCorretoresKanban';
import EventosList from './pages/Vendas/EventosList';
import EventoCheckinScanner from './pages/Vendas/EventoCheckinScanner';
import EventoPublico from './pages/Publico/EventoPublico';
import ConvitePublico from './pages/Publico/ConvitePublico';
import AgendamentoPublico from './pages/Publico/AgendamentoPublico';
import ImobiliariasList from './pages/Vendas/ImobiliariasList';
import ContratosList from './pages/Vendas/ContratosList';
import BoletosList from './pages/Vendas/BoletosList';
import UsuariosVendasList from './pages/Vendas/UsuariosVendasList';
import EnviosMassa from './pages/EnviosMassa/EnviosMassa';
import Aquecimento from './pages/Aquecimento/Aquecimento';
import Blacklist from './pages/Blacklist/Blacklist';
import WhatsAppManager from './pages/WhatsApp/WhatsAppManager';
import WhatsAppOficial from './pages/WhatsAppOficial/WhatsAppOficial';
import ChatwootEmbed from './pages/Marketing/ChatwootEmbed';
import PostizEmbed from './pages/Marketing/PostizEmbed';
import QRCodeGenerator from './pages/Marketing/QRCodeGenerator';
import GestorTrafego from './pages/Marketing/GestorTrafego';
import CriarImagens from './pages/Marketing/CriarImagens';
import EmailMarketing from './pages/EmailMarketing/EmailMarketing';
import Agendamentos from './pages/Agendamentos/Agendamentos';
import Automacoes from './pages/Automacoes/Automacoes';
import Agenda from './pages/Agenda/Agenda';
import SdrVoz from './pages/Comunicacoes/SdrVoz';
import HistoricoLigacoes from './pages/Comunicacoes/HistoricoLigacoes';
import AgendaCalDiy from './pages/Comunicacoes/AgendaCalDiy';
import SistemaNotificacoes from './pages/Comunicacoes/SistemaNotificacoes';
import NumerosNaoAtendidos from './pages/Comunicacoes/NumerosNaoAtendidos';
import WhatsAppWeb from './pages/Comunicacoes/WhatsAppWeb';
import useWhatsAppWebAcesso from './hooks/useWhatsAppWebAcesso';
import TeamDetails from './pages/Agenda/TeamDetails/TeamDetails';
import EstoqueDashboard from './pages/Estoque/EstoqueDashboard';
import EstoqueListagem from './pages/Estoque/EstoqueListagem';
import EstoqueItem from './pages/Estoque/EstoqueItem';
import EstoqueNovo from './pages/Estoque/EstoqueNovo';
import EstoqueAlertas from './pages/Estoque/EstoqueAlertas';
import EstoqueScanner from './pages/Estoque/EstoqueScanner';
import EstoqueGeradorQR from './pages/Estoque/EstoqueGeradorQR';
import EstoqueConfiguracoes from './pages/Estoque/EstoqueConfiguracoes';
import EstoqueFuncionarios from './pages/Estoque/EstoqueFuncionarios';
import EstoqueMovimentacaoDiaria from './pages/Estoque/EstoqueMovimentacaoDiaria';
import InsumosDashboard from './pages/Insumos/InsumosDashboard';
import InsumosMateriais from './pages/Insumos/InsumosMateriais';
import InsumosEntrada from './pages/Insumos/InsumosEntrada';
import InsumosSaida from './pages/Insumos/InsumosSaida';
import InsumosPedidos from './pages/Insumos/InsumosPedidos';
import InsumosFornecedores from './pages/Insumos/InsumosFornecedores';
import InsumosAlertas from './pages/Insumos/InsumosAlertas';
import InsumosTransferencias from './pages/Insumos/InsumosTransferencias';
import InsumosInventario from './pages/Insumos/InsumosInventario';

function getUser() {
  try { return JSON.parse(localStorage.getItem('user') || 'null'); } catch { return null; }
}

function PrivateRoute({ children }) {
  return localStorage.getItem('token') ? children : <Navigate to="/login" />;
}

const PORTAL_VENDAS_URL = 'https://vendas.construtorainbase.com.br';

// Destino de corretores do portal de vendas que caem no CRM: redireciona pro
// portal de vendas (onde a gestão de materiais e o espelho realmente vivem).
function ExternalRedirect({ href = PORTAL_VENDAS_URL }) {
  React.useEffect(() => { window.location.href = href; }, [href]);
  return <div style={{ padding: 40, fontFamily: 'sans-serif' }}>Redirecionando…</div>;
}

function getDefaultPath(user) {
  if (!user) return '/login';
  const mods = user.modulos_permitidos;
  if (!mods || mods.includes('dashboard')) return '/dashboard';
  // Corretor do portal de vendas não usa o CRM — a gestão de materiais foi movida
  // para o painel do inbase-vendas. Manda pro portal de vendas.
  if (mods.includes('portal_corretor')) return '/portal-vendas';
  if (mods.includes('estoque') || mods.some(m => m.startsWith('estoque.'))) {
    if (mods.includes('estoque') || mods.includes('estoque.dashboard')) return '/estoque';
    if (mods.includes('estoque.itens')) return '/estoque/itens';
    if (mods.includes('estoque.alertas')) return '/estoque/alertas';
    return '/estoque';
  }
  if (mods.includes('leads')) return '/leads';
  return '/dashboard';
}

function ModuleRoute({ modulo, children }) {
  const user = getUser();
  if (!user) return <Navigate to="/login" />;
  if (user.perfil === 'admin') return children;
  const mods = user.modulos_permitidos;
  if (!mods) return children;
  if (mods.includes(modulo) || mods.some(m => m.startsWith(modulo + '.'))) return children;
  return <Navigate to={getDefaultPath(user)} replace />;
}

function EstoqueRoute({ sub, children }) {
  const user = getUser();
  if (!user) return <Navigate to="/login" />;
  if (user.perfil === 'admin') return children;
  const mods = user.modulos_permitidos;
  if (!mods) return children;
  if (mods.includes('estoque') || mods.includes(`estoque.${sub}`)) return children;
  return <Navigate to={getDefaultPath(user)} replace />;
}

// Só os logins liberados no backend (WHATSAPP_WEB_USUARIOS) — os demais caem no início.
function WhatsAppWebRoute({ children }) {
  const { permitido, carregando } = useWhatsAppWebAcesso();
  if (carregando) return null;
  return permitido ? children : <Navigate to={getDefaultPath(getUser())} replace />;
}

function AdminRoute({ children }) {
  const user = getUser();
  if (!user) return <Navigate to="/login" />;
  return user.perfil === 'admin' ? children : <Navigate to={getDefaultPath(user)} replace />;
}

export default function App() {
  return (
    <BrowserRouter>
      <PwaInstallPrompt />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/portal-vendas" element={<ExternalRedirect />} />
        <Route path="/recuperar-senha" element={<RecuperarSenha />} />
        <Route path="/redefinir-senha" element={<RedefinirSenha />} />
        <Route path="/publico/eventos/:id" element={<EventoPublico />} />
        <Route path="/publico/convite/:token" element={<ConvitePublico />} />
        <Route path="/publico/agendamento/:token" element={<AgendamentoPublico />} />
        <Route path="/vendas/eventos/checkin" element={<EventoCheckinScanner />} />
        <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
          <Route index element={<Navigate to={getDefaultPath(getUser())} replace />} />
          <Route path="dashboard" element={<ModuleRoute modulo="dashboard"><Dashboard /></ModuleRoute>} />
          <Route path="leads" element={<ModuleRoute modulo="leads"><LeadsList /></ModuleRoute>} />
          <Route path="leads/kanban" element={<ModuleRoute modulo="leads"><LeadKanban /></ModuleRoute>} />
          <Route path="leads/:id" element={<ModuleRoute modulo="leads"><LeadDetail /></ModuleRoute>} />
          <Route path="leads-reaquecidos" element={<ModuleRoute modulo="leads"><LeadsReaquecidosList /></ModuleRoute>} />
          <Route path="leads-sdr-voz" element={<ModuleRoute modulo="leads"><LeadsSDRVoz /></ModuleRoute>} />
          <Route path="empreendimentos" element={<ModuleRoute modulo="empreendimentos"><EmpreendimentosList /></ModuleRoute>} />
          <Route path="empreendimentos/:id/espelho" element={<ModuleRoute modulo="empreendimentos"><EspelhoVendas /></ModuleRoute>} />
          <Route path="imoveis" element={<ModuleRoute modulo="imoveis"><ImovelList /></ModuleRoute>} />
          <Route path="imoveis/novo" element={<ModuleRoute modulo="imoveis"><ImovelForm /></ModuleRoute>} />
          <Route path="imoveis/gerar" element={<ModuleRoute modulo="imoveis"><GerarDeUnidade /></ModuleRoute>} />
          <Route path="imoveis/:id" element={<ModuleRoute modulo="imoveis"><ImovelDetail /></ModuleRoute>} />
          <Route path="imoveis/:id/editar" element={<ModuleRoute modulo="imoveis"><ImovelForm /></ModuleRoute>} />
          <Route path="pipeline" element={<ModuleRoute modulo="pipeline"><PipelineKanban /></ModuleRoute>} />
          <Route path="portais" element={<ModuleRoute modulo="portais"><PortaisSync /></ModuleRoute>} />
          <Route path="configuracoes/integracoes" element={<ModuleRoute modulo="configuracoes"><Integracoes /></ModuleRoute>} />
          <Route path="usuarios" element={<AdminRoute><UsuariosList /></AdminRoute>} />
          <Route path="portal-clientes" element={<ModuleRoute modulo="portal_clientes"><PortalClientesList /></ModuleRoute>} />
          <Route path="portal-clientes/evolucao" element={<ModuleRoute modulo="portal_clientes"><EvolucaoObra /></ModuleRoute>} />
          <Route path="portal-clientes/chamados" element={<ModuleRoute modulo="portal_clientes"><Chamados /></ModuleRoute>} />
          <Route path="portal-clientes/reajuste-incc" element={<ModuleRoute modulo="portal_clientes"><ReajusteINCC /></ModuleRoute>} />
          <Route path="propostas" element={<ModuleRoute modulo="propostas"><PropostasList /></ModuleRoute>} />
          <Route path="vendas/clientes" element={<ModuleRoute modulo="propostas"><ClientesList /></ModuleRoute>} />
          <Route path="vendas/corretores" element={<ModuleRoute modulo="propostas"><CorretoresList /></ModuleRoute>} />
          <Route path="vendas/parceiros" element={<ModuleRoute modulo="propostas"><ParceirosList /></ModuleRoute>} />
          <Route path="vendas/parceiros/:corretorId" element={<ModuleRoute modulo="propostas"><ParceiroDetail /></ModuleRoute>} />
          <Route path="vendas/funil-corretores" element={<ModuleRoute modulo="propostas"><FunilCorretoresKanban /></ModuleRoute>} />
          <Route path="vendas/eventos" element={<ModuleRoute modulo="propostas"><EventosList /></ModuleRoute>} />
          <Route path="vendas/corretores-reaquecidos" element={<ModuleRoute modulo="propostas"><CorretoresReaquecidos /></ModuleRoute>} />
          <Route path="vendas/elo" element={<ModuleRoute modulo="propostas"><Elo /></ModuleRoute>} />
          <Route path="vendas/imobiliarias" element={<ModuleRoute modulo="propostas"><ImobiliariasList /></ModuleRoute>} />
          <Route path="vendas/propostas" element={<ModuleRoute modulo="propostas"><PropostasList /></ModuleRoute>} />
          <Route path="vendas/pre-reservas" element={<ModuleRoute modulo="propostas"><PreReservasList /></ModuleRoute>} />
          <Route path="vendas/contratos" element={<ModuleRoute modulo="propostas"><ContratosList /></ModuleRoute>} />
          <Route path="vendas/boletos" element={<ModuleRoute modulo="propostas"><BoletosList /></ModuleRoute>} />
          <Route path="vendas/usuarios-vendas" element={<ModuleRoute modulo="portal_corretor"><UsuariosVendasList /></ModuleRoute>} />
          <Route path="envios-massa" element={<ModuleRoute modulo="envios_massa"><EnviosMassa /></ModuleRoute>} />
          <Route path="aquecimento" element={<ModuleRoute modulo="envios_massa"><Aquecimento /></ModuleRoute>} />
          <Route path="blacklist" element={<ModuleRoute modulo="envios_massa"><Blacklist /></ModuleRoute>} />
          <Route path="whatsapp" element={<ModuleRoute modulo="whatsapp"><WhatsAppManager /></ModuleRoute>} />
          <Route path="whatsapp-oficial" element={<ModuleRoute modulo="whatsapp"><WhatsAppOficial /></ModuleRoute>} />
          <Route path="agendamentos" element={<ModuleRoute modulo="whatsapp"><Agendamentos /></ModuleRoute>} />
          <Route path="automacoes" element={<ModuleRoute modulo="whatsapp"><Automacoes /></ModuleRoute>} />
          <Route path="comunicacoes/sdr-voz" element={<ModuleRoute modulo="whatsapp"><SdrVoz /></ModuleRoute>} />
          <Route path="comunicacoes/historico-ligacoes" element={<ModuleRoute modulo="whatsapp"><HistoricoLigacoes /></ModuleRoute>} />
          <Route path="comunicacoes/agenda-caldiy" element={<ModuleRoute modulo="whatsapp"><AgendaCalDiy /></ModuleRoute>} />
          <Route path="comunicacoes/notificacoes" element={<ModuleRoute modulo="whatsapp"><SistemaNotificacoes /></ModuleRoute>} />
          <Route path="comunicacoes/numeros-nao-atendidos" element={<ModuleRoute modulo="whatsapp"><NumerosNaoAtendidos /></ModuleRoute>} />
          <Route path="comunicacoes/whatsapp-web" element={<WhatsAppWebRoute><WhatsAppWeb /></WhatsAppWebRoute>} />
          <Route path="comunicacoes/blacklist" element={<ModuleRoute modulo="whatsapp"><Blacklist /></ModuleRoute>} />
          <Route path="agenda" element={<ModuleRoute modulo="agenda"><Agenda /></ModuleRoute>} />
          <Route path="agenda/equipes/:id" element={<ModuleRoute modulo="agenda"><TeamDetails /></ModuleRoute>} />
          <Route path="estoque" element={<EstoqueRoute sub="dashboard"><EstoqueDashboard /></EstoqueRoute>} />
          <Route path="estoque/itens" element={<EstoqueRoute sub="itens"><EstoqueListagem /></EstoqueRoute>} />
          <Route path="estoque/novo" element={<EstoqueRoute sub="novo"><EstoqueNovo /></EstoqueRoute>} />
          <Route path="estoque/itens/:id" element={<EstoqueRoute sub="itens"><EstoqueItem /></EstoqueRoute>} />
          <Route path="estoque/alertas" element={<EstoqueRoute sub="alertas"><EstoqueAlertas /></EstoqueRoute>} />
          <Route path="estoque/scanner" element={<EstoqueScanner />} />
          <Route path="estoque/gerador-qr" element={<EstoqueRoute sub="gerador_qr"><EstoqueGeradorQR /></EstoqueRoute>} />
          <Route path="estoque/funcionarios" element={<EstoqueRoute sub="itens"><EstoqueFuncionarios /></EstoqueRoute>} />
          <Route path="estoque/movimentacao-diaria" element={<EstoqueRoute sub="itens"><EstoqueMovimentacaoDiaria /></EstoqueRoute>} />
          <Route path="estoque/configuracoes" element={<EstoqueRoute sub="configuracoes"><EstoqueConfiguracoes /></EstoqueRoute>} />
          <Route path="insumos" element={<EstoqueRoute sub="dashboard"><InsumosDashboard /></EstoqueRoute>} />
          <Route path="insumos/materiais" element={<EstoqueRoute sub="itens"><InsumosMateriais /></EstoqueRoute>} />
          <Route path="insumos/entrada" element={<EstoqueRoute sub="itens"><InsumosEntrada /></EstoqueRoute>} />
          <Route path="insumos/saida" element={<EstoqueRoute sub="itens"><InsumosSaida /></EstoqueRoute>} />
          <Route path="insumos/pedidos" element={<EstoqueRoute sub="itens"><InsumosPedidos /></EstoqueRoute>} />
          <Route path="insumos/fornecedores" element={<EstoqueRoute sub="itens"><InsumosFornecedores /></EstoqueRoute>} />
          <Route path="insumos/alertas" element={<EstoqueRoute sub="alertas"><InsumosAlertas /></EstoqueRoute>} />
          <Route path="insumos/transferencias" element={<EstoqueRoute sub="itens"><InsumosTransferencias /></EstoqueRoute>} />
          <Route path="insumos/inventario" element={<EstoqueRoute sub="itens"><InsumosInventario /></EstoqueRoute>} />
          <Route path="marketing/chatwoot" element={<ModuleRoute modulo="marketing"><ChatwootEmbed /></ModuleRoute>} />
          <Route path="marketing/postiz" element={<ModuleRoute modulo="marketing"><PostizEmbed /></ModuleRoute>} />
          <Route path="marketing/trafego" element={<ModuleRoute modulo="marketing"><GestorTrafego /></ModuleRoute>} />
          <Route path="marketing/imagens" element={<ModuleRoute modulo="marketing"><CriarImagens /></ModuleRoute>} />
          <Route path="marketing/qrcode" element={<ModuleRoute modulo="marketing"><QRCodeGenerator /></ModuleRoute>} />
          <Route path="marketing/email" element={<ModuleRoute modulo="marketing"><EmailMarketing /></ModuleRoute>} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
